// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/v2.109.0/js/" + "flags" + "." + "b9bcddcf9b698ae97b2e" + ".js";
};